export default __webpack_public_path__ + "static/media/chartView.4c3609c7.svg";